import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    tag: "span",
    variant: "text",
    icon: "",
    class: "card-action no-drag",
    role: "button",
    tabindex: "0",
    title: _ctx.title,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('act', $event)), ["stop","prevent"])),
    onKeydown: [
      _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('act', $event)), ["stop","prevent"]), ["enter"])),
      _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('act', $event)), ["stop","prevent"]), ["space"]))
    ]
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_icon, { size: "16" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.icon), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}